import * as ActionTypes from 'client/features/flashes/actions'
import _ from 'underscore'

const initialState = {
    all: []
}

const initializeState = () => Object.assign({}, initialState)

export default function flashes(state = initializeState(), action = {}) {
    switch (action.type) {

    case ActionTypes.NEW_FLASH:
        return { ...state, all: [...state.all, action.flash] }

    case ActionTypes.HIDE_FLASH:
        return { ...state, all: _.without(state.all, _.findWhere(state.all, { date: action.flash.date })) }
			
    default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/client/features/flashes/reducers.js